import { styled } from '../../../lib/stitches'
import { appear } from '../animations'

const VisualizerContainer = styled('div', {
  position: 'relative',
  flex: '1',
  background: '$gray02',
  borderRadius: '10px',
  overflow: 'hidden',
  display: 'flex',
  alignItems: 'stretch',
  flexDirection: 'column',
  padding: '8px',
  boxShadow: '1px 1px 10px -4px #00000026 inset',
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  animation: `${appear} 500ms cubic-bezier(0.16, 1, 0.3, 1)`
})

export default VisualizerContainer
